export enum LocationType {
  UNKNOWN = 0,
  ASSIGMENT_AREA = 1,
  UNDEFINED = 2,
  BUILDING = 3,
  FLOOR = 4,
  CORRIDOR = 5,
  ROOM = 6,
  BED = 7,
  TOILET = 8,
}
